var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcGallery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-ic_gallery"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_gallery",
    clipPath: "url(#clip-ic_gallery)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_11",
    "data-name": "\\uC0AC\\uAC01\\uD615 11",
    width: 80,
    height: 80,
    fill: "none",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_17",
    "data-name": "\\uD328\\uC2A4 17",
    d: "M48.144,0H55V39H0V31.018",
    transform: "translate(19 27)",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_16",
    "data-name": "\\uD328\\uC2A4 16",
    d: "M0,29.276V37H54V0H46.17",
    transform: "translate(13 21)",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_8",
    "data-name": "\\uC0AC\\uAC01\\uD615 8",
    transform: "translate(6 14)",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 37,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 52,
    height: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_4",
    "data-name": "\\uD569\\uCE58\\uAE30 4",
    d: "M13.4-268.836,0-249.616l13.4-19.22L13.29-269l.114.164.114-.164-.114.164L32.611-241.3Z",
    transform: "translate(7.076 291.032)",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_2",
    "data-name": "\\uD569\\uCE58\\uAE30 2",
    d: "M5.1-268.836,0-261.516l5.1-7.32L4.99-269l.114.164L5.219-269l-.114.164L17.4-251.2Z",
    transform: "translate(32.5 301.516)",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_1",
    "data-name": "\\uD0C0\\uC6D0 1",
    transform: "translate(42 22)",
    fill: "none",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_3",
    "data-name": "\\uD569\\uCE58\\uAE30 3",
    d: "M10.573-268.837,10.459-269l.114.163.114-.163-.114.163,2.8,4.021-2.8-4.021L0-253.676Z",
    transform: "translate(45.542 298.032)",
    fill: "none",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGallery);
export default __webpack_public_path__ + "static/media/ic_gallery.c94ac261f906a6b05e11b7d1e6e18ff9.svg";
export { ForwardRef as ReactComponent };